export type Province = {
  code: string;
  translationKey: string;
};

export type Country = {
  code: string;
  translationKey: string;
  provinces: Province[];
};

export const locationData: Country[] = [
  {
    code: 'CA',
    translationKey: 'countries.canada',
    provinces: [
      { code: 'AB', translationKey: 'provinces.alberta' },
      { code: 'BC', translationKey: 'provinces.britishColumbia' },
      { code: 'MB', translationKey: 'provinces.manitoba' },
      { code: 'NB', translationKey: 'provinces.newBrunswick' },
      { code: 'NL', translationKey: 'provinces.newfoundlandAndLabrador' },
      { code: 'NS', translationKey: 'provinces.novaScotia' },
      { code: 'ON', translationKey: 'provinces.ontario' },
      { code: 'PE', translationKey: 'provinces.princeEdwardIsland' },
      { code: 'QC', translationKey: 'provinces.quebec' },
      { code: 'SK', translationKey: 'provinces.saskatchewan' },
      { code: 'NT', translationKey: 'provinces.northwestTerritories' },
      { code: 'NU', translationKey: 'provinces.nunavut' },
      { code: 'YT', translationKey: 'provinces.yukon' }
    ]
  },
  {
    code: 'US',
    translationKey: 'countries.unitedStates',
    provinces: [
      { code: 'AL', translationKey: 'states.alabama' },
      { code: 'AK', translationKey: 'states.alaska' },
      { code: 'AZ', translationKey: 'states.arizona' },
      { code: 'AR', translationKey: 'states.arkansas' },
      { code: 'CA', translationKey: 'states.california' },
      { code: 'CO', translationKey: 'states.colorado' },
      { code: 'CT', translationKey: 'states.connecticut' },
      { code: 'DE', translationKey: 'states.delaware' },
      { code: 'FL', translationKey: 'states.florida' },
      { code: 'GA', translationKey: 'states.georgia' },
      { code: 'HI', translationKey: 'states.hawaii' },
      { code: 'ID', translationKey: 'states.idaho' },
      { code: 'IL', translationKey: 'states.illinois' },
      { code: 'IN', translationKey: 'states.indiana' },
      { code: 'IA', translationKey: 'states.iowa' },
      { code: 'KS', translationKey: 'states.kansas' },
      { code: 'KY', translationKey: 'states.kentucky' },
      { code: 'LA', translationKey: 'states.louisiana' },
      { code: 'ME', translationKey: 'states.maine' },
      { code: 'MD', translationKey: 'states.maryland' },
      { code: 'MA', translationKey: 'states.massachusetts' },
      { code: 'MI', translationKey: 'states.michigan' },
      { code: 'MN', translationKey: 'states.minnesota' },
      { code: 'MS', translationKey: 'states.mississippi' },
      { code: 'MO', translationKey: 'states.missouri' },
      { code: 'MT', translationKey: 'states.montana' },
      { code: 'NE', translationKey: 'states.nebraska' },
      { code: 'NV', translationKey: 'states.nevada' },
      { code: 'NH', translationKey: 'states.newHampshire' },
      { code: 'NJ', translationKey: 'states.newJersey' },
      { code: 'NM', translationKey: 'states.newMexico' },
      { code: 'NY', translationKey: 'states.newYork' },
      { code: 'NC', translationKey: 'states.northCarolina' },
      { code: 'ND', translationKey: 'states.northDakota' },
      { code: 'OH', translationKey: 'states.ohio' },
      { code: 'OK', translationKey: 'states.oklahoma' },
      { code: 'OR', translationKey: 'states.oregon' },
      { code: 'PA', translationKey: 'states.pennsylvania' },
      { code: 'RI', translationKey: 'states.rhodeIsland' },
      { code: 'SC', translationKey: 'states.southCarolina' },
      { code: 'SD', translationKey: 'states.southDakota' },
      { code: 'TN', translationKey: 'states.tennessee' },
      { code: 'TX', translationKey: 'states.texas' },
      { code: 'UT', translationKey: 'states.utah' },
      { code: 'VT', translationKey: 'states.vermont' },
      { code: 'VA', translationKey: 'states.virginia' },
      { code: 'WA', translationKey: 'states.washington' },
      { code: 'WV', translationKey: 'states.westVirginia' },
      { code: 'WI', translationKey: 'states.wisconsin' },
      { code: 'WY', translationKey: 'states.wyoming' }
    ]
  }
];
